export default __webpack_public_path__ + "static/media/price.460794dc.svg";